import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { libraryImages } from '../../images/library-images';
@Injectable()
export class LibraryHelper {
  constructor() {}
  public baseUrl = environment.nodeApiUrl + '/' + environment.api_prefix;

  fileThumbbyName(file) {
    if (file?.file_type === 'application/pdf') {
      if (file?.thumb == undefined || file?.thumb == '') {
        return libraryImages?.pdf_icon;
      } else {
        return file.thumb;
      }
    } else if (file?.file_type === 'image/png') {
      return libraryImages?.png_icon;
    } else if (file?.file_type === 'image/jpeg') {
      return libraryImages?.jpg_icon;
    } else if (file?.file_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      return libraryImages?.doc_icon;
    } else if (file?.file_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return libraryImages?.xls_icon;
    } else if (file?.file_type === 'application/vnd.ms-powerpoint') {
      return libraryImages?.ppt_icon;
    } else if (file?.file_type === 'application/x-zip-compressed') {
      return libraryImages?.zip_icon;
    } else if (file?.file_type === 'text/html') {
      return libraryImages?.html_icon;
    } else if (file?.file_type === 'text/plain') {
      return libraryImages?.text_icon;
    } else if (file?.file_type === 'application/json') {
      return libraryImages?.json_icon;
    } else if (file?.file_type === 'text/xml') {
      return libraryImages?.xml_icon;
    } else if (file?.file_type === 'font/ttf') {
      return libraryImages?.text_file_icon;
    } else if (file?.type === 'matrix') {
      return libraryImages?.lib_file_image;
    } else {
      return libraryImages?.lib_file_image;
    }
  }
}
